export default __webpack_public_path__ + "static/media/artwork-card-4.0367a6a8.png";